import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMeter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 10.5935 21.1948 9.2603 20.6478 8.06132C20.4759 7.68447 20.642 7.2396 21.0188 7.06766C21.3957 6.89573 21.8405 7.06184 22.0125 7.43868C22.6469 8.82921 23 10.3744 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C13.6256 1 15.1708 1.35311 16.5613 1.98754C16.9382 2.15947 17.1043 2.60434 16.9323 2.98119C16.7604 3.35803 16.3155 3.52414 15.9387 3.35221C14.7397 2.80518 13.4065 2.5 12 2.5ZM21.0303 2.96967C21.3232 3.26256 21.3232 3.73744 21.0303 4.03033L14.5846 10.476C14.8486 10.9227 15 11.4436 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C12.5564 9 13.0773 9.15145 13.524 9.41536L19.9697 2.96967C20.2626 2.67678 20.7374 2.67678 21.0303 2.96967ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgMeter;
